module.exports = __webpack_public_path__ + "static/media/cellfinate_banner_que_es_cellfina_mobile.07cffcf0.jpg";